

export const CategorySideMenu = (props) => {
    return (
        <div className="side-menu-category">
            <p className="side-menu-category-title">{props.title}</p>
            <hr className="side-menu-category-line"/>
        </div>
    )
}